<template>
  <div :class="clss" :style="style"
       v-on:click="handleChoice">
    <template v-if="hasImage">
      <figure>
        <img :src="content.item.img" :alt="content.item.label" />
      </figure>
    </template>
    {{ content.item.label }}
    <template v-if="hasDesc">
      <div class="small">{{ content.item.desc }}</div>
    </template>
  </div>
</template>

<script>
import BaseMessage from '@/components/messages/BaseMessage.vue'

export default {
  name: 'ContentChoice',
  extends: BaseMessage,
  computed: {
    clss () {
      return `chawgt-webchat-choice ${this.content.disabled === true ? 'chawgt-webchat-disabled' : ''}`
    },
    hasDesc () {
      if (this.content.item.desc !== '') {
        return true
      }
      return false
    },
    hasImage () {
      if (this.content.item.img) {
        return true
      }
      return false
    },
    style () {
      if (this.content.from === 'bot') {
        return this.$store.getters['webchat/getBotMsgStyle']
      }
      return ''
    }
  },
  methods: {
    handleChoice () {
      if (this.content.disabled === false) {
        if (this.content.kind === 'choice') {
          if (this.content.item.uuid !== null) {
            // should be choice
            const richContent = {
              kind: 'choosed',
              item: {
                uuid: this.content.item.uuid,
                label: this.content.item.label,
                desc: this.content.desc,
                img: this.content.icon
              }
            }
            this.$store.dispatch({
              type: 'webchat/sendMsg',
              content: this.content.item.label,
              richContent: richContent
            })
          } else {
            // this.sendMsg(this.content.uuid, this.content.content)
          }
        }
      }
      this.$store.commit('webchat/disablePreviousChoices', this.content.item.uuid)
    }
    // handleChoice () {
    //   if (this.content.disabled === false) {
    //     if (this.content.kind === 'choice') {
    //       if (this.content.item.uuid !== null) {
    //         // should be choice
    //         const richContent = {
    //           kind: 'choosed',
    //           item: {
    //             uuid: this.content.item.uuid,
    //             label: this.content.item.label,
    //             desc: this.content.desc,
    //             img: this.content.icon
    //           }
    //         }
    //         this.$store.dispatch({
    //           type: 'sendMsg',
    //           content: this.content.item.label,
    //           richContent: richContent
    //         })
    //       } else {
    //         // this.sendMsg(this.content.uuid, this.content.content)
    //       }
    //     }
    //   }
    //   this.$store.commit(
    //     'disablePreviousChoices', this.content.item.uuid)
    // }
  }
}

</script>

<style lang="scss" scoped>
div {
  cursor: pointer;
  font-weight: bold;
}

.chawgt-webchat-choice {
  border: none;
  border-radius: 20px 20px 20px 8px;
  display: block;
  font-size: 14px !important;
  font-weight: 400 !important;
  hyphens: auto;
  -webkit-hyphens: auto;
  margin: 3px 5px;
  padding: 20px;
  max-width: 75%;
  text-align: left;
  text-transform: none !important;
  width: 65%;
}

.chawgt-webchat-choice a,
.chawgt-webchat-choice a:active,
.chawgt-webchat-choice a:focus,
.chawgt-webchat-choice a:hover,
button.chawgt-webchat-choice {
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
}

.chawgt-webchat-choice.chawgt-webchat-disabled {
  opacity: 0.4
}

button.chawgt-webchat-choice.chawgt-webchat-disabled,
button.chawgt-webchat-choice.chawgt-webchat-disabled span {
  background: #eceff2 !important;
  color: #687177!important;
  cursor: default;
  opacity: 0.4;
}

.chawgt-webchat-choice .chawgt-webchat-icon {
  background-size: 20px 20px;
  background-repeat: no-repeat;
  background-position: 5% 50%;
  padding-left: 40px;
}

img {
  max-width: 160px;
}
</style>
